import React from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { TeacherSignUpLayout } from '../TeacherSignUpLayout';
export const TeacherSignUp = () => {
  return <div className="w-full min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white font-sans" data-id="element-9526">
      <Navbar data-id="element-9527" />
      <main data-id="element-9528">
        <TeacherSignUpLayout data-id="element-9529" />
      </main>
      <Footer data-id="element-9530" />
    </div>;
};